import { TableHeaderItem } from "@/views/components/YtoTable/TableHeaderItem";

// const defaultWidth = 300;

const tableHeader: TableHeaderItem[] = [
  { prop: 'index', label: '序号', width: null },
  { prop: 'strCarCode', label: '车签号', width: null },
  { prop: 'strBackSigntureCode', label: '后门铅封号', width: null },
  { prop: 'strLineNoName', label: '线路', width: null },
  { prop: 'strLineFrequency', label: '频次', width: null },
  { prop: 'strCarCodeInfo', label: '车辆信息条码', width: null },
  { prop: 'strMidSigntureCode', label: '中门铅封号', width: null },
  { prop: 'strLoadingVolume', label: '装载方数', width: null },
  { prop: 'strResolveTime', label: '发车时间', width: null },
  { prop: 'state', label: '状态', width: null },
  { prop: 'strTip', label: '提示/警告信息', width: null },
];
export default { tableHeader }
